import React from 'react';

export const SommaireTab = ({ data = {}, setData }) => {
  // Hooks doivent être en premier
  const updateStatut = React.useCallback((section, field, value) => {
    setData(prev => ({
      ...prev,
      sommaire: {
        ...prev.sommaire,
        [section]: {
          ...prev.sommaire?.[section],
          [field]: value
        }
      }
    }));
  }, [setData]);

  // Protection contre les données manquantes
  if (!data) {
    return (
      <div className="text-center py-10 text-gray-500">
        Données du sommaire non disponibles.
      </div>
    );
  }

  const StatutSelect = ({ value, onChange }) => (
    <select 
      value={value || 'A faire'} 
      onChange={(e) => onChange(e.target.value)}
      className={`px-3 py-1 rounded border ${
        value === 'OK' ? 'bg-green-100 border-green-300 text-green-800' :
        value === 'En cours' ? 'bg-yellow-100 border-yellow-300 text-yellow-800' :
        value === 'A faire' ? 'bg-red-100 border-red-300 text-red-800' :
        'bg-gray-100 border-gray-300 text-gray-800'
      }`}
    >
      <option value="OK">OK</option>
      <option value="En cours">En cours</option>
      <option value="A faire">A faire</option>
      <option value="N/A">N/A</option>
    </select>
  );

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Tableau de Bord du Dossier d'Ingénierie</h2>
      
      {/* Section INFORMATION PROJET / CLIENT */}
      <div>
        <h3 className="text-lg font-semibold text-blue-700 mb-4 border-b-2 border-blue-200 pb-2">
          INFORMATION PROJET / CLIENT
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Onglet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Initialisation</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Projet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Run</th>
              </tr>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-4 py-2"></th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Identité projet</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.identiteProjet?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.identiteProjet?.statut} 
                    onChange={(val) => updateStatut('identiteProjet', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.identiteProjet?.responsableProjet}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.identiteProjet?.statutProjet} 
                    onChange={(val) => updateStatut('identiteProjet', 'statutProjet', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.identiteProjet?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.identiteProjet?.statutRun} 
                    onChange={(val) => updateStatut('identiteProjet', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Annuaire Site</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.annuaireSite?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.annuaireSite?.statut} 
                    onChange={(val) => updateStatut('annuaireSite', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.annuaireSite?.responsableProjet}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.annuaireSite?.statutProjet} 
                    onChange={(val) => updateStatut('annuaireSite', 'statutProjet', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.annuaireSite?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.annuaireSite?.statutRun} 
                    onChange={(val) => updateStatut('annuaireSite', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Connexion aux environnements</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm"></td>
                <td className="border border-gray-300 px-4 py-2 text-center"></td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.connexionEnvironnements?.responsableProjet}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.connexionEnvironnements?.statutProjet} 
                    onChange={(val) => updateStatut('connexionEnvironnements', 'statutProjet', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.connexionEnvironnements?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.connexionEnvironnements?.statutRun} 
                    onChange={(val) => updateStatut('connexionEnvironnements', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Checklist</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm"></td>
                <td className="border border-gray-300 px-4 py-2 text-center"></td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.checklist?.responsableProjet}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.checklist?.statutProjet} 
                    onChange={(val) => updateStatut('checklist', 'statutProjet', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center" colSpan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Section MODULES */}
      <div>
        <h3 className="text-lg font-semibold text-green-700 mb-4 border-b-2 border-green-200 pb-2">
          MODULES
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Onglet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Initialisation</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Projet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Run</th>
              </tr>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-4 py-2"></th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Modules</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.modules?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.modules?.statut} 
                    onChange={(val) => updateStatut('modules', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.modules?.responsableProjet}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.modules?.statutProjet} 
                    onChange={(val) => updateStatut('modules', 'statutProjet', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.modules?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.modules?.statutRun} 
                    onChange={(val) => updateStatut('modules', 'statutRun', val)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Section ARCHITECTURE / ENVIRONNEMENT / INTERFACES */}
      <div>
        <h3 className="text-lg font-semibold text-purple-700 mb-4 border-b-2 border-purple-200 pb-2">
          ARCHITECTURE / ENVIRONNEMENT / INTERFACES
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Onglet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Projet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Run</th>
              </tr>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-4 py-2"></th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Architecture PROD</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.architectureProd?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.architectureProd?.statut} 
                    onChange={(val) => updateStatut('architectureProd', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.architectureProd?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.architectureProd?.statutRun} 
                    onChange={(val) => updateStatut('architectureProd', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Fiche d'installation PROD</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.ficheInstallProd?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.ficheInstallProd?.statut} 
                    onChange={(val) => updateStatut('ficheInstallProd', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.ficheInstallProd?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.ficheInstallProd?.statutRun} 
                    onChange={(val) => updateStatut('ficheInstallProd', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Matrice des flux PROD</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.matriceFluxProd?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.matriceFluxProd?.statut} 
                    onChange={(val) => updateStatut('matriceFluxProd', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.matriceFluxProd?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.matriceFluxProd?.statutRun} 
                    onChange={(val) => updateStatut('matriceFluxProd', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-blue-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Architecture QUAL</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.architectureQual?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.architectureQual?.statut} 
                    onChange={(val) => updateStatut('architectureQual', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.architectureQual?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.architectureQual?.statutRun} 
                    onChange={(val) => updateStatut('architectureQual', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-blue-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Fiche d'installation QUAL</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.ficheInstallQual?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.ficheInstallQual?.statut} 
                    onChange={(val) => updateStatut('ficheInstallQual', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.ficheInstallQual?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.ficheInstallQual?.statutRun} 
                    onChange={(val) => updateStatut('ficheInstallQual', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-blue-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Matrice des flux QUAL</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.matriceFluxQual?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.matriceFluxQual?.statut} 
                    onChange={(val) => updateStatut('matriceFluxQual', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.matriceFluxQual?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.matriceFluxQual?.statutRun} 
                    onChange={(val) => updateStatut('matriceFluxQual', 'statutRun', val)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Section USAGE METIER */}
      <div>
        <h3 className="text-lg font-semibold text-orange-700 mb-4 border-b-2 border-orange-200 pb-2">
          USAGE MÉTIER
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Onglet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Projet</th>
                <th className="border border-gray-300 px-4 py-2" colSpan="2">Mise à jour Phase Run</th>
              </tr>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-4 py-2"></th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Resp</th>
                <th className="border border-gray-300 px-4 py-2 text-sm">Statut</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2 font-medium">Workflow Suivi Connecté</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.workflowSuiviConnecte?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.workflowSuiviConnecte?.statut} 
                    onChange={(val) => updateStatut('workflowSuiviConnecte', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.workflowSuiviConnecte?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.workflowSuiviConnecte?.statutRun} 
                    onChange={(val) => updateStatut('workflowSuiviConnecte', 'statutRun', val)}
                  />
                </td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 px-4 py-2 font-medium">Workflow Dossier Administratif</td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.workflowDossierAdmin?.responsable}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.workflowDossierAdmin?.statut} 
                    onChange={(val) => updateStatut('workflowDossierAdmin', 'statut', val)}
                  />
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center text-sm">{data.workflowDossierAdmin?.responsableRun}</td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  <StatutSelect 
                    value={data.workflowDossierAdmin?.statutRun} 
                    onChange={(val) => updateStatut('workflowDossierAdmin', 'statutRun', val)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Légende des statuts */}
      <div className="mt-8 p-4 bg-gray-50 rounded-lg">
        <h4 className="font-semibold mb-2">Statuts possibles :</h4>
        <div className="flex gap-4 flex-wrap">
          <span className="px-3 py-1 bg-green-100 text-green-800 rounded">OK</span>
          <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded">En cours</span>
          <span className="px-3 py-1 bg-red-100 text-red-800 rounded">A faire</span>
          <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded">N/A</span>
        </div>
      </div>
    </div>
  );
};